import { ModalVariant, ModalVariantClass } from './modal.types';

export const MODAL_VARIANTS: Record<ModalVariant, ModalVariantClass> = {
    [ModalVariant.small]: 'modal-sm',
    [ModalVariant.medium]: 'modal-md',
    [ModalVariant.large]: 'modal-lg',
    [ModalVariant.xlarge]: 'modal-xl',
};
